var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fas fa-circle fa-stack-2x"}),_c('i',{staticClass:"fas fa-check fa-stack-1x fa-inverse"})])}]

export { render, staticRenderFns }